import script from "./ForgottenPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&setup=true&lang=js"

import "./ForgottenPassword.vue?vue&type=style&index=0&id=199a35f5&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199a35f5"]])

export default __exports__